// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"xT9uMj21ubtDIABY0gVw","classificationCheckboxContainer":"GGbTsA7oIPazsE1lf7Q7","checkbox":"kea9tqkbz0thfRgxyMFX","label":"OSHmZx5pumVDQdO8SbxQ"};